export default __webpack_public_path__ + "static/media/socials2.3bfa549c.png";